var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-bg"},[_c('h1',[_vm._v(_vm._s(_vm.$t('pages.verify-announcement.thank-you', 'Thanks for signing up. Please verify your account.')))]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        'pages.verify-announcement.system-use-caption',
        'To use the {portal} platform, you must verify your account. An email has been sent to {email} with a link to verify your account. If you have not received the email after a few minutes, please check your spam folder.',
        {
          portal: _vm.appName,
          email: _vm.email,
        }
      ))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }